import { createAction } from '@reduxjs/toolkit'

import type {
  TDataRerunDetailDto,
  TDataRerunSummaryDto,
  TRerunCandidatesDto
} from '@homepal/api-contract'

// tryGetRerunCandidates
export const getCandidates = createAction<{ customerId?: string }>(
  'internal_get_rerun_candidates'
)
export const getCandidatesSuccess = createAction<{
  data: TRerunCandidatesDto
  customerId?: string
}>('internal_get_rerun_candidates_success')
export const getCandidatesFailed = createAction<{ customerId?: string }>(
  'internal_get_rerun_candidates_failed'
)

// tryCreateRerun
export const create = createAction('internal_create_rerun')
export const createSuccess = createAction('internal_create_rerun_success')
export const createFailed = createAction('internal_create_rerun_failed')

// tryGetReruns
export const getReruns = createAction('internal_get_data_reruns')
export const getRerunsSuccess = createAction<TDataRerunSummaryDto[]>(
  'internal_get_data_reruns_success'
)
export const getRerunsFailed = createAction('internal_get_data_reruns_failed')

// tryGetActiveReruns
export const getActiveReruns = createAction('internal_get_active_data_reruns')
export const getActiveRerunsSuccess = createAction<TDataRerunSummaryDto[]>(
  'internal_get_active_data_reruns_success'
)
export const getActiveRerunsFailed = createAction(
  'internal_get_active_data_reruns_failed'
)

// tryGetRerun
export const getRerun = createAction<{ id: string }>('internal_get_data_rerun')
export const getRerunSuccess = createAction<TDataRerunDetailDto>(
  'internal_get_data_rerun_success'
)
export const getRerunFailed = createAction<{ id: string }>(
  'internal_get_data_rerun_failed'
)

// tryCancelRerun
export const cancel = createAction('internal_cancel_data_rerun')
export const cancelSuccess = createAction('internal_cancel_data_rerun_success')
export const cancelFailed = createAction('internal_cancel_data_rerun_failed')

// tryRetryFailedRerun
export const retryFailed = createAction('internal_retry_failed_data_rerun')
export const retryFailedSuccess = createAction(
  'internal_retry_failed_data_rerun_success'
)
export const retryFailedFailed = createAction(
  'internal_retry_failed_data_rerun_failed'
)
